import { TextField } from '@mui/material';
import { type EdgeProps, useReactFlow } from '@xyflow/react';

import { type ReactFlowGroupNode } from '../../../../../types';

interface GroupNodeNameFieldProps {
  nodeId: string;
  label: string;
}

export function GroupNodeNameField(props: GroupNodeNameFieldProps) {
  const { nodeId, label } = props;
  const { updateNodeData } = useReactFlow<ReactFlowGroupNode, EdgeProps>();
  return (
    <TextField
      value={label}
      aria-label="Group name"
      placeholder="Group name"
      variant="standard"
      slotProps={{
        input: {
          disableUnderline: true,
        },
      }}
      onChange={async (event) => {
        const inputElement = event.target;
        const { selectionStart, selectionEnd } = inputElement;
        updateNodeData(nodeId, {
          label: event.target.value,
        });
        await Promise.resolve().then(() => {
          inputElement.setSelectionRange(selectionStart, selectionEnd);
        });
      }}
      /**
       * Prevent cut/copy/paste events from bubbling up to ReactFlow
       * which would otherwise trigger node copy/paste
       */
      onCut={(event) => {
        event.stopPropagation();
      }}
      onCopy={(event) => {
        event.stopPropagation();
      }}
      onPaste={(event) => {
        event.stopPropagation();
      }}
    />
  );
}
